import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import {
  AntiMoneyLaunderingParameters,
  Owner,
  PledgeOwnerRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  get pledgeOwners() {
    return this.form.get('pledgeOwners') as UntypedFormArray;
  }
  generate(entity: Owner[], accountId: number) {
    let pledgeOwners: UntypedFormGroup[] = [];
    const owners = entity;
    if (!!owners && owners?.length) {
      for (let owner of owners) {
        const antiMoneyLaunderingFormGroup = this.formBuilder.group({
          id: [owner?.antiMoneyLaundering?.id || null],
          ownerId: [owner?.antiMoneyLaundering?.ownerId || null],
          accountId: [owner?.antiMoneyLaundering?.accountId || accountId],
          beneficialOwnerId: [
            owner?.antiMoneyLaundering?.beneficialOwnerId || null,
          ],
          profile: ['MORAL'],
          institutionFinanciere: [
            _.isNil(owner?.antiMoneyLaundering?.institutionFinanciere)
              ? false
              : owner?.antiMoneyLaundering?.institutionFinanciere,
            Validators.required,
          ],
          autoriteOrganismePublic: [
            _.isNil(owner?.antiMoneyLaundering?.autoriteOrganismePublic)
              ? false
              : owner?.antiMoneyLaundering?.autoriteOrganismePublic,
            Validators.required,
          ],
          societeCotee: [
            _.isNil(owner?.antiMoneyLaundering?.societeCotee)
              ? false
              : owner?.antiMoneyLaundering?.societeCotee,
            Validators.required,
          ],
          rbePpe: [
            _.isNil(owner?.antiMoneyLaundering?.rbePpe)
              ? false
              : owner?.antiMoneyLaundering?.rbePpe,
            Validators.required,
          ],
          structureAnonymat: [
            _.isNil(owner?.antiMoneyLaundering?.structureAnonymat)
              ? false
              : owner?.antiMoneyLaundering?.structureAnonymat,
            Validators.required,
          ],
          recoursDomiciliation: [
            _.isNil(owner?.antiMoneyLaundering?.recoursDomiciliation)
              ? false
              : owner?.antiMoneyLaundering?.recoursDomiciliation,
            Validators.required,
          ],
          secteurCorruptionBlanchiment: [
            _.isNil(owner?.antiMoneyLaundering?.secteurCorruptionBlanchiment)
              ? false
              : owner?.antiMoneyLaundering?.secteurCorruptionBlanchiment,
            Validators.required,
          ],
          changementStatutsSansJustification: [
            _.isNil(
              owner?.antiMoneyLaundering?.changementStatutsSansJustification,
            )
              ? false
              : owner?.antiMoneyLaundering?.changementStatutsSansJustification,
            Validators.required,
          ],
          representantDiscretionInhabituelle: [
            _.isNil(
              owner?.antiMoneyLaundering?.representantDiscretionInhabituelle,
            )
              ? false
              : owner?.antiMoneyLaundering?.representantDiscretionInhabituelle,
            Validators.required,
          ],
          personneListeGelsDesAvoirs: [
            _.isNil(owner?.antiMoneyLaundering?.personneListeGelsDesAvoirs)
              ? false
              : owner?.antiMoneyLaundering?.personneListeGelsDesAvoirs,
            Validators.required,
          ],
          fondListeGelsDesAvoirs: [
            _.isNil(owner?.antiMoneyLaundering?.fondListeGelsDesAvoirs)
              ? false
              : owner?.antiMoneyLaundering?.fondListeGelsDesAvoirs,
            Validators.required,
          ],
          versementPeePerco: [
            _.isNil(owner?.antiMoneyLaundering?.versementPeePerco)
              ? false
              : owner?.antiMoneyLaundering?.versementPeePerco,
            Validators.required,
          ],
          produitsAtypiques: [
            _.isNil(owner?.antiMoneyLaundering?.produitsAtypiques)
              ? false
              : owner?.antiMoneyLaundering?.produitsAtypiques,
            Validators.required,
          ],
          controleActifsFonds: [
            _.isNil(owner?.antiMoneyLaundering?.controleActifsFonds)
              ? false
              : owner?.antiMoneyLaundering?.controleActifsFonds,
            Validators.required,
          ],
          compteTitreAugmentationCapital: [
            _.isNil(owner?.antiMoneyLaundering?.compteTitreAugmentationCapital)
              ? false
              : owner?.antiMoneyLaundering?.compteTitreAugmentationCapital,
            Validators.required,
          ],
          primeAnnuelleUnique: [
            _.isNil(owner?.antiMoneyLaundering?.primeAnnuelleUnique)
              ? false
              : owner?.antiMoneyLaundering?.primeAnnuelleUnique,
            Validators.required,
          ],
          contratPrevoyanceSante: [
            _.isNil(owner?.antiMoneyLaundering?.contratPrevoyanceSante)
              ? false
              : owner?.antiMoneyLaundering?.contratPrevoyanceSante,
            Validators.required,
          ],
          assuranceEmprunteur: [
            _.isNil(owner?.antiMoneyLaundering?.assuranceEmprunteur)
              ? false
              : owner?.antiMoneyLaundering?.assuranceEmprunteur,
            Validators.required,
          ],
          contratAssuranceSansClauseRachat: [
            _.isNil(
              owner?.antiMoneyLaundering?.contratAssuranceSansClauseRachat,
            )
              ? false
              : owner?.antiMoneyLaundering?.contratAssuranceSansClauseRachat,
            Validators.required,
          ],
          contratAnonyme: [
            _.isNil(owner?.antiMoneyLaundering?.contratAnonyme)
              ? false
              : owner?.antiMoneyLaundering?.contratAnonyme,
            Validators.required,
          ],
          produitsImmobiliersLuxe: [
            _.isNil(owner?.antiMoneyLaundering?.produitsImmobiliersLuxe)
              ? false
              : owner?.antiMoneyLaundering?.produitsImmobiliersLuxe,
            Validators.required,
          ],
          operationPaysGafi: [
            _.isNil(owner?.antiMoneyLaundering?.operationPaysGafi)
              ? false
              : owner?.antiMoneyLaundering?.operationPaysGafi,
            Validators.required,
          ],
          fondPaysGafi: [
            _.isNil(owner?.antiMoneyLaundering?.fondPaysGafi)
              ? false
              : owner?.antiMoneyLaundering?.fondPaysGafi,
            Validators.required,
          ],
          operationPaysNonCooperatif: [
            _.isNil(owner?.antiMoneyLaundering?.operationPaysNonCooperatif)
              ? false
              : owner?.antiMoneyLaundering?.operationPaysNonCooperatif,
            Validators.required,
          ],
          fondPaysNonCooperatif: [
            _.isNil(owner?.antiMoneyLaundering?.fondPaysNonCooperatif)
              ? false
              : owner?.antiMoneyLaundering?.fondPaysNonCooperatif,
            Validators.required,
          ],
        });

        const companyFormGroup = this.formBuilder.group({
          name: [owner?.company?.name || null],
        });

        const formConfig: FormConfig<
          PledgeOwnerRead & {
            antiMoneyLaundering: AntiMoneyLaunderingParameters;
          }
        > = {
          id: [owner.id],
          ownerId: [owner.ownerId],
          userId: [owner.userId],
          company: companyFormGroup,
          userFirstName: [owner.userFirstName],
          userLastName: [owner.userLastName],
          antiMoneyLaundering: antiMoneyLaunderingFormGroup,
        };

        const formBuilderGroup = this.formBuilder.group(formConfig, {});
        pledgeOwners.push(formBuilderGroup);
      }
    }

    let group = this.formBuilder.group({
      pledgeOwners: this.formBuilder.array(
        pledgeOwners,
        Validators.nullValidator,
      ),
    });

    this.form = group;

    return group;
  }

  extract() {
    const formValue = _.cloneDeep(this.form.value.pledgeOwners);

    return { owners: formValue };
  }
}
